'use client'

import { MergeTagServiceClient } from 'shared/gen/manager/core/proto/merge-tags.client'

import {
  GetUnitMergeTagsRequest,
  GetUnitMergeTagsResponse,
  HydrateMergeTagsRequest,
  HydrateMergeTagsResponse,
} from 'shared/gen/manager/core/proto/merge-tags'
import { makeWebTransport } from 'shared/services/grpc/web-transport'
import logger from 'shared/services/logger'

let client: MergeTagServiceClient | null = null

import { K2ServerActionUseCase } from 'shared/services/grpc/k2-use-case'

export const getUnitMergeTags = K2ServerActionUseCase<
  GetUnitMergeTagsRequest,
  GetUnitMergeTagsResponse
>(
  (request) => {
    return generateMergeTagClient().getUnitMergeTags(request)
  },
  {
    loggerOptions: { feature: logger.Feature.MergeTags },
    defaultErrorMessage: 'Something went wrong when loading the merge tags.',
  },
)

export const hydrateMergeTags = K2ServerActionUseCase<
  HydrateMergeTagsRequest,
  HydrateMergeTagsResponse
>(
  (request) => {
    return generateMergeTagClient().hydrateMergeTags(request)
  },
  {
    loggerOptions: { feature: logger.Feature.MergeTags },
    defaultErrorMessage:
      'Something went wrong when loading the unit merge tags.',
  },
)

//============---------==========-----------============//
// PRIVATE

const generateMergeTagClient = () => {
  if (!client) client = new MergeTagServiceClient(makeWebTransport())
  return client
}
